// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: rtc/web_socket.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FixType, fixTypeFromJSON, fixTypeToJSON } from "../geo/geo";
import { Empty } from "../google/protobuf/empty";
import { DeviceLocationHistoryRecord } from "./device_location_history";
import {
  Checklist,
  ChecklistExemption,
  Intervention,
  Job,
  JobConfiguration,
  Objective,
  ObjectiveAssignment,
  RobotJobAssignment,
  Task,
} from "./jobs";
import { LocationHistoryRecord } from "./location_history";
import { ActiveIntervener } from "./rocc";

export const protobufPackage = "carbon.rtc";

export enum SubscriptionDeviceType {
  SUBSCRIPTION_DEVICE_TYPE_UNSPECIFIED = 0,
  ROBOT = 1,
  DEVICE = 2,
  PIVOT_ALERT = 3,
  UNRECOGNIZED = -1,
}

export function subscriptionDeviceTypeFromJSON(object: any): SubscriptionDeviceType {
  switch (object) {
    case 0:
    case "SUBSCRIPTION_DEVICE_TYPE_UNSPECIFIED":
      return SubscriptionDeviceType.SUBSCRIPTION_DEVICE_TYPE_UNSPECIFIED;
    case 1:
    case "ROBOT":
      return SubscriptionDeviceType.ROBOT;
    case 2:
    case "DEVICE":
      return SubscriptionDeviceType.DEVICE;
    case 3:
    case "PIVOT_ALERT":
      return SubscriptionDeviceType.PIVOT_ALERT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SubscriptionDeviceType.UNRECOGNIZED;
  }
}

export function subscriptionDeviceTypeToJSON(object: SubscriptionDeviceType): string {
  switch (object) {
    case SubscriptionDeviceType.SUBSCRIPTION_DEVICE_TYPE_UNSPECIFIED:
      return "SUBSCRIPTION_DEVICE_TYPE_UNSPECIFIED";
    case SubscriptionDeviceType.ROBOT:
      return "ROBOT";
    case SubscriptionDeviceType.DEVICE:
      return "DEVICE";
    case SubscriptionDeviceType.PIVOT_ALERT:
      return "PIVOT_ALERT";
    case SubscriptionDeviceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SubscriptionRequestType {
  SUBSCRIPTION_REQUEST_TYPE_UNSPECIFIED = 0,
  SUBSCRIBE = 1,
  UNSUBSCRIBE = 2,
  UNRECOGNIZED = -1,
}

export function subscriptionRequestTypeFromJSON(object: any): SubscriptionRequestType {
  switch (object) {
    case 0:
    case "SUBSCRIPTION_REQUEST_TYPE_UNSPECIFIED":
      return SubscriptionRequestType.SUBSCRIPTION_REQUEST_TYPE_UNSPECIFIED;
    case 1:
    case "SUBSCRIBE":
      return SubscriptionRequestType.SUBSCRIBE;
    case 2:
    case "UNSUBSCRIBE":
      return SubscriptionRequestType.UNSUBSCRIBE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SubscriptionRequestType.UNRECOGNIZED;
  }
}

export function subscriptionRequestTypeToJSON(object: SubscriptionRequestType): string {
  switch (object) {
    case SubscriptionRequestType.SUBSCRIPTION_REQUEST_TYPE_UNSPECIFIED:
      return "SUBSCRIPTION_REQUEST_TYPE_UNSPECIFIED";
    case SubscriptionRequestType.SUBSCRIBE:
      return "SUBSCRIBE";
    case SubscriptionRequestType.UNSUBSCRIBE:
      return "UNSUBSCRIBE";
    case SubscriptionRequestType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PivotAlertUnknownReason {
  REASON_UNSPECIFIED = 0,
  REASON_OUTSIDE_ALL_TRACKED_PIVOTS = 1,
  REASON_PIVOT_LOCATION_STALE = 2,
  REASON_FARM_DATA_STALE = 3,
  REASON_INTERNAL_ERROR = 4,
  UNRECOGNIZED = -1,
}

export function pivotAlertUnknownReasonFromJSON(object: any): PivotAlertUnknownReason {
  switch (object) {
    case 0:
    case "REASON_UNSPECIFIED":
      return PivotAlertUnknownReason.REASON_UNSPECIFIED;
    case 1:
    case "REASON_OUTSIDE_ALL_TRACKED_PIVOTS":
      return PivotAlertUnknownReason.REASON_OUTSIDE_ALL_TRACKED_PIVOTS;
    case 2:
    case "REASON_PIVOT_LOCATION_STALE":
      return PivotAlertUnknownReason.REASON_PIVOT_LOCATION_STALE;
    case 3:
    case "REASON_FARM_DATA_STALE":
      return PivotAlertUnknownReason.REASON_FARM_DATA_STALE;
    case 4:
    case "REASON_INTERNAL_ERROR":
      return PivotAlertUnknownReason.REASON_INTERNAL_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PivotAlertUnknownReason.UNRECOGNIZED;
  }
}

export function pivotAlertUnknownReasonToJSON(object: PivotAlertUnknownReason): string {
  switch (object) {
    case PivotAlertUnknownReason.REASON_UNSPECIFIED:
      return "REASON_UNSPECIFIED";
    case PivotAlertUnknownReason.REASON_OUTSIDE_ALL_TRACKED_PIVOTS:
      return "REASON_OUTSIDE_ALL_TRACKED_PIVOTS";
    case PivotAlertUnknownReason.REASON_PIVOT_LOCATION_STALE:
      return "REASON_PIVOT_LOCATION_STALE";
    case PivotAlertUnknownReason.REASON_FARM_DATA_STALE:
      return "REASON_FARM_DATA_STALE";
    case PivotAlertUnknownReason.REASON_INTERNAL_ERROR:
      return "REASON_INTERNAL_ERROR";
    case PivotAlertUnknownReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum UpdateType {
  UPDATE_TYPE_UNSPECIFIED = 0,
  UPDATE_TYPE_CREATE = 1,
  UPDATE_TYPE_UPDATE = 2,
  UPDATE_TYPE_DELETE = 3,
  UNRECOGNIZED = -1,
}

export function updateTypeFromJSON(object: any): UpdateType {
  switch (object) {
    case 0:
    case "UPDATE_TYPE_UNSPECIFIED":
      return UpdateType.UPDATE_TYPE_UNSPECIFIED;
    case 1:
    case "UPDATE_TYPE_CREATE":
      return UpdateType.UPDATE_TYPE_CREATE;
    case 2:
    case "UPDATE_TYPE_UPDATE":
      return UpdateType.UPDATE_TYPE_UPDATE;
    case 3:
    case "UPDATE_TYPE_DELETE":
      return UpdateType.UPDATE_TYPE_DELETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UpdateType.UNRECOGNIZED;
  }
}

export function updateTypeToJSON(object: UpdateType): string {
  switch (object) {
    case UpdateType.UPDATE_TYPE_UNSPECIFIED:
      return "UPDATE_TYPE_UNSPECIFIED";
    case UpdateType.UPDATE_TYPE_CREATE:
      return "UPDATE_TYPE_CREATE";
    case UpdateType.UPDATE_TYPE_UPDATE:
      return "UPDATE_TYPE_UPDATE";
    case UpdateType.UPDATE_TYPE_DELETE:
      return "UPDATE_TYPE_DELETE";
    case UpdateType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum WebSocketStatus {
  WEB_SOCKET_STATUS_UNSPECIFIED = 0,
  OK = 1,
  ERROR = 2,
  UNRECOGNIZED = -1,
}

export function webSocketStatusFromJSON(object: any): WebSocketStatus {
  switch (object) {
    case 0:
    case "WEB_SOCKET_STATUS_UNSPECIFIED":
      return WebSocketStatus.WEB_SOCKET_STATUS_UNSPECIFIED;
    case 1:
    case "OK":
      return WebSocketStatus.OK;
    case 2:
    case "ERROR":
      return WebSocketStatus.ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WebSocketStatus.UNRECOGNIZED;
  }
}

export function webSocketStatusToJSON(object: WebSocketStatus): string {
  switch (object) {
    case WebSocketStatus.WEB_SOCKET_STATUS_UNSPECIFIED:
      return "WEB_SOCKET_STATUS_UNSPECIFIED";
    case WebSocketStatus.OK:
      return "OK";
    case WebSocketStatus.ERROR:
      return "ERROR";
    case WebSocketStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** @deprecated */
export interface SubscriptionRequest {
  type: SubscriptionRequest_Type;
  device: DeviceSelector | undefined;
  excludeFixTypes: FixType[];
}

export enum SubscriptionRequest_Type {
  TYPE_UNSPECIFIED = 0,
  SUBSCRIBE = 1,
  UNSUBSCRIBE = 2,
  UNRECOGNIZED = -1,
}

export function subscriptionRequest_TypeFromJSON(object: any): SubscriptionRequest_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return SubscriptionRequest_Type.TYPE_UNSPECIFIED;
    case 1:
    case "SUBSCRIBE":
      return SubscriptionRequest_Type.SUBSCRIBE;
    case 2:
    case "UNSUBSCRIBE":
      return SubscriptionRequest_Type.UNSUBSCRIBE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SubscriptionRequest_Type.UNRECOGNIZED;
  }
}

export function subscriptionRequest_TypeToJSON(object: SubscriptionRequest_Type): string {
  switch (object) {
    case SubscriptionRequest_Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case SubscriptionRequest_Type.SUBSCRIBE:
      return "SUBSCRIBE";
    case SubscriptionRequest_Type.UNSUBSCRIBE:
      return "UNSUBSCRIBE";
    case SubscriptionRequest_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface LocatorServiceSubscriptionRequest {
  type: SubscriptionRequestType;
  device: DeviceSelector | undefined;
  excludeFixTypes: FixType[];
}

export interface JobServiceSubscriptionRequest {
  type: SubscriptionRequestType;
  target: JobServiceSubscriptionRequest_Target;
  /** When subscribing to the JOB or JOB_CONFIG target, which job_id? */
  jobId?:
    | number
    | undefined;
  /** When subscribing to the OBJECTIVE target, which objective_id? */
  objectiveId?:
    | number
    | undefined;
  /** When subscribing to the ROBOT target, which robot_serial? */
  robotSerial?:
    | string
    | undefined;
  /** When subscribing to the TASK target, which task_id? */
  taskId?:
    | number
    | undefined;
  /** when subscribing to the INTERVENER_SESSION target, which user id? */
  userId?: string | undefined;
}

export enum JobServiceSubscriptionRequest_Target {
  TARGET_UNSPECIFIED = 0,
  /** INTERVENTIONS - Create/Update/Delete of interventions */
  INTERVENTIONS = 1,
  /** JOB - Create/Update/Delete of a job or its objectives */
  JOB = 2,
  /** OBJECTIVE - Create/Update/Delete of an objective or its tasks */
  OBJECTIVE = 3,
  /** ROBOT - Update of a robot's active job/objective/task/checklist */
  ROBOT = 4,
  /** TASK - Update/Delete of a single task */
  TASK = 5,
  /** JOB_CONFIG - Update of a job's configuration settings */
  JOB_CONFIG = 6,
  /** INTERVENER_SESSION - Update of an intervener's session. i.e. which */
  INTERVENER_SESSION = 7,
  UNRECOGNIZED = -1,
}

export function jobServiceSubscriptionRequest_TargetFromJSON(object: any): JobServiceSubscriptionRequest_Target {
  switch (object) {
    case 0:
    case "TARGET_UNSPECIFIED":
      return JobServiceSubscriptionRequest_Target.TARGET_UNSPECIFIED;
    case 1:
    case "INTERVENTIONS":
      return JobServiceSubscriptionRequest_Target.INTERVENTIONS;
    case 2:
    case "JOB":
      return JobServiceSubscriptionRequest_Target.JOB;
    case 3:
    case "OBJECTIVE":
      return JobServiceSubscriptionRequest_Target.OBJECTIVE;
    case 4:
    case "ROBOT":
      return JobServiceSubscriptionRequest_Target.ROBOT;
    case 5:
    case "TASK":
      return JobServiceSubscriptionRequest_Target.TASK;
    case 6:
    case "JOB_CONFIG":
      return JobServiceSubscriptionRequest_Target.JOB_CONFIG;
    case 7:
    case "INTERVENER_SESSION":
      return JobServiceSubscriptionRequest_Target.INTERVENER_SESSION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobServiceSubscriptionRequest_Target.UNRECOGNIZED;
  }
}

export function jobServiceSubscriptionRequest_TargetToJSON(object: JobServiceSubscriptionRequest_Target): string {
  switch (object) {
    case JobServiceSubscriptionRequest_Target.TARGET_UNSPECIFIED:
      return "TARGET_UNSPECIFIED";
    case JobServiceSubscriptionRequest_Target.INTERVENTIONS:
      return "INTERVENTIONS";
    case JobServiceSubscriptionRequest_Target.JOB:
      return "JOB";
    case JobServiceSubscriptionRequest_Target.OBJECTIVE:
      return "OBJECTIVE";
    case JobServiceSubscriptionRequest_Target.ROBOT:
      return "ROBOT";
    case JobServiceSubscriptionRequest_Target.TASK:
      return "TASK";
    case JobServiceSubscriptionRequest_Target.JOB_CONFIG:
      return "JOB_CONFIG";
    case JobServiceSubscriptionRequest_Target.INTERVENER_SESSION:
      return "INTERVENER_SESSION";
    case JobServiceSubscriptionRequest_Target.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface DeviceSelector {
  type: SubscriptionDeviceType;
  serial?: string | undefined;
  deviceId?: string | undefined;
}

/** @deprecated */
export interface SubscriptionMessage {
  type: SubscriptionMessage_Type;
  location?: LocationUpdate | undefined;
}

export enum SubscriptionMessage_Type {
  TYPE_UNSPECIFIED = 0,
  LOCATION = 1,
  UNRECOGNIZED = -1,
}

export function subscriptionMessage_TypeFromJSON(object: any): SubscriptionMessage_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return SubscriptionMessage_Type.TYPE_UNSPECIFIED;
    case 1:
    case "LOCATION":
      return SubscriptionMessage_Type.LOCATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SubscriptionMessage_Type.UNRECOGNIZED;
  }
}

export function subscriptionMessage_TypeToJSON(object: SubscriptionMessage_Type): string {
  switch (object) {
    case SubscriptionMessage_Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case SubscriptionMessage_Type.LOCATION:
      return "LOCATION";
    case SubscriptionMessage_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface LocatorServiceSubscriptionMessage {
  type: LocatorServiceSubscriptionMessage_Type;
  location?: LocationUpdate | undefined;
}

export enum LocatorServiceSubscriptionMessage_Type {
  TYPE_UNSPECIFIED = 0,
  LOCATION = 1,
  UNRECOGNIZED = -1,
}

export function locatorServiceSubscriptionMessage_TypeFromJSON(object: any): LocatorServiceSubscriptionMessage_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return LocatorServiceSubscriptionMessage_Type.TYPE_UNSPECIFIED;
    case 1:
    case "LOCATION":
      return LocatorServiceSubscriptionMessage_Type.LOCATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LocatorServiceSubscriptionMessage_Type.UNRECOGNIZED;
  }
}

export function locatorServiceSubscriptionMessage_TypeToJSON(object: LocatorServiceSubscriptionMessage_Type): string {
  switch (object) {
    case LocatorServiceSubscriptionMessage_Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case LocatorServiceSubscriptionMessage_Type.LOCATION:
      return "LOCATION";
    case LocatorServiceSubscriptionMessage_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PivotAlertUnknownData {
  reasons: PivotAlertUnknownReason[];
}

export interface PivotAlertAlertedData {
  responsiblePivotZoneId: string;
}

export interface PivotAlertState {
  robotSerial: string;
  unknown?: PivotAlertUnknownData | undefined;
  allClear?: Empty | undefined;
  alerted?: PivotAlertAlertedData | undefined;
}

export interface LocationUpdate {
  device: DeviceSelector | undefined;
  robotRec?: LocationHistoryRecord | undefined;
  deviceRec?: DeviceLocationHistoryRecord | undefined;
  pivotAlert?: PivotAlertState | undefined;
}

export interface JobServiceSubscriptionMessage {
  type: JobServiceSubscriptionMessage_Type;
  activeObjective?: ActiveObjectiveUpdate | undefined;
  activeAtomicTask?: ActiveAtomicTaskUpdate | undefined;
  job?: JobUpdate | undefined;
  objective?: ObjectiveUpdate | undefined;
  task?: TaskUpdate | undefined;
  intervention?: InterventionUpdate | undefined;
  objectiveAssignment?: ObjectiveAssignmentUpdate | undefined;
  jobConfig?: JobConfigUpdate | undefined;
  checklist?: ChecklistUpdate | undefined;
  checklistExemption?: ChecklistExemptionUpdate | undefined;
  jobAssignment?: JobAssignmentUpdate | undefined;
  intervenerSession?: IntervenerSessionUpdate | undefined;
}

export enum JobServiceSubscriptionMessage_Type {
  TYPE_UNSPECIFIED = 0,
  ACTIVE_OBJECTIVE = 1,
  ACTIVE_ATOMIC_TASK = 2,
  JOB = 3,
  OBJECTIVE = 4,
  TASK = 5,
  INTERVENTION = 6,
  OBJECTIVE_ASSIGNMENT = 7,
  JOB_CONFIG = 8,
  CHECKLIST = 9,
  CHECKLIST_EXEMPTION = 10,
  JOB_ASSIGNMENT = 11,
  INTERVENER_SESSION = 12,
  UNRECOGNIZED = -1,
}

export function jobServiceSubscriptionMessage_TypeFromJSON(object: any): JobServiceSubscriptionMessage_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return JobServiceSubscriptionMessage_Type.TYPE_UNSPECIFIED;
    case 1:
    case "ACTIVE_OBJECTIVE":
      return JobServiceSubscriptionMessage_Type.ACTIVE_OBJECTIVE;
    case 2:
    case "ACTIVE_ATOMIC_TASK":
      return JobServiceSubscriptionMessage_Type.ACTIVE_ATOMIC_TASK;
    case 3:
    case "JOB":
      return JobServiceSubscriptionMessage_Type.JOB;
    case 4:
    case "OBJECTIVE":
      return JobServiceSubscriptionMessage_Type.OBJECTIVE;
    case 5:
    case "TASK":
      return JobServiceSubscriptionMessage_Type.TASK;
    case 6:
    case "INTERVENTION":
      return JobServiceSubscriptionMessage_Type.INTERVENTION;
    case 7:
    case "OBJECTIVE_ASSIGNMENT":
      return JobServiceSubscriptionMessage_Type.OBJECTIVE_ASSIGNMENT;
    case 8:
    case "JOB_CONFIG":
      return JobServiceSubscriptionMessage_Type.JOB_CONFIG;
    case 9:
    case "CHECKLIST":
      return JobServiceSubscriptionMessage_Type.CHECKLIST;
    case 10:
    case "CHECKLIST_EXEMPTION":
      return JobServiceSubscriptionMessage_Type.CHECKLIST_EXEMPTION;
    case 11:
    case "JOB_ASSIGNMENT":
      return JobServiceSubscriptionMessage_Type.JOB_ASSIGNMENT;
    case 12:
    case "INTERVENER_SESSION":
      return JobServiceSubscriptionMessage_Type.INTERVENER_SESSION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobServiceSubscriptionMessage_Type.UNRECOGNIZED;
  }
}

export function jobServiceSubscriptionMessage_TypeToJSON(object: JobServiceSubscriptionMessage_Type): string {
  switch (object) {
    case JobServiceSubscriptionMessage_Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case JobServiceSubscriptionMessage_Type.ACTIVE_OBJECTIVE:
      return "ACTIVE_OBJECTIVE";
    case JobServiceSubscriptionMessage_Type.ACTIVE_ATOMIC_TASK:
      return "ACTIVE_ATOMIC_TASK";
    case JobServiceSubscriptionMessage_Type.JOB:
      return "JOB";
    case JobServiceSubscriptionMessage_Type.OBJECTIVE:
      return "OBJECTIVE";
    case JobServiceSubscriptionMessage_Type.TASK:
      return "TASK";
    case JobServiceSubscriptionMessage_Type.INTERVENTION:
      return "INTERVENTION";
    case JobServiceSubscriptionMessage_Type.OBJECTIVE_ASSIGNMENT:
      return "OBJECTIVE_ASSIGNMENT";
    case JobServiceSubscriptionMessage_Type.JOB_CONFIG:
      return "JOB_CONFIG";
    case JobServiceSubscriptionMessage_Type.CHECKLIST:
      return "CHECKLIST";
    case JobServiceSubscriptionMessage_Type.CHECKLIST_EXEMPTION:
      return "CHECKLIST_EXEMPTION";
    case JobServiceSubscriptionMessage_Type.JOB_ASSIGNMENT:
      return "JOB_ASSIGNMENT";
    case JobServiceSubscriptionMessage_Type.INTERVENER_SESSION:
      return "INTERVENER_SESSION";
    case JobServiceSubscriptionMessage_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ActiveObjectiveUpdate {
  type: UpdateType;
  objective: Objective | undefined;
}

export interface ActiveAtomicTaskUpdate {
  type: UpdateType;
  task: Task | undefined;
}

export interface JobUpdate {
  type: UpdateType;
  job: Job | undefined;
}

export interface JobConfigUpdate {
  type: UpdateType;
  configuration: JobConfiguration | undefined;
}

export interface ObjectiveUpdate {
  type: UpdateType;
  objective: Objective | undefined;
}

export interface TaskUpdate {
  type: UpdateType;
  task: Task | undefined;
}

export interface InterventionUpdate {
  type: UpdateType;
  intervention: Intervention | undefined;
}

export interface IntervenerSessionUpdate {
  type: UpdateType;
  session: ActiveIntervener | undefined;
}

export interface JobAssignmentUpdate {
  type: UpdateType;
  jobAssignment: RobotJobAssignment | undefined;
}

export interface ObjectiveAssignmentUpdate {
  type: UpdateType;
  objectiveAssignment: ObjectiveAssignment | undefined;
}

export interface ChecklistUpdate {
  type: UpdateType;
  checklist: Checklist | undefined;
}

export interface ChecklistExemptionUpdate {
  type: UpdateType;
  checklistExemption: ChecklistExemption | undefined;
}

export interface WebSocketAuthenticateRequest {
  token: string;
  audience: string;
}

export interface WebSocketResponse {
  status: WebSocketStatus;
  message: string;
}

function createBaseSubscriptionRequest(): SubscriptionRequest {
  return { type: 0, device: undefined, excludeFixTypes: [] };
}

export const SubscriptionRequest: MessageFns<SubscriptionRequest> = {
  encode(message: SubscriptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.device !== undefined) {
      DeviceSelector.encode(message.device, writer.uint32(18).fork()).join();
    }
    writer.uint32(26).fork();
    for (const v of message.excludeFixTypes) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscriptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.device = DeviceSelector.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.excludeFixTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.excludeFixTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionRequest {
    return {
      type: isSet(object.type) ? subscriptionRequest_TypeFromJSON(object.type) : 0,
      device: isSet(object.device) ? DeviceSelector.fromJSON(object.device) : undefined,
      excludeFixTypes: globalThis.Array.isArray(object?.excludeFixTypes)
        ? object.excludeFixTypes.map((e: any) => fixTypeFromJSON(e))
        : globalThis.Array.isArray(object?.exclude_fix_types)
        ? object.exclude_fix_types.map((e: any) => fixTypeFromJSON(e))
        : [],
    };
  },

  toJSON(message: SubscriptionRequest): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = subscriptionRequest_TypeToJSON(message.type);
    }
    if (message.device !== undefined) {
      obj.device = DeviceSelector.toJSON(message.device);
    }
    if (message.excludeFixTypes?.length) {
      obj.excludeFixTypes = message.excludeFixTypes.map((e) => fixTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionRequest>, I>>(base?: I): SubscriptionRequest {
    return SubscriptionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionRequest>, I>>(object: I): SubscriptionRequest {
    const message = createBaseSubscriptionRequest();
    message.type = object.type ?? 0;
    message.device = (object.device !== undefined && object.device !== null)
      ? DeviceSelector.fromPartial(object.device)
      : undefined;
    message.excludeFixTypes = object.excludeFixTypes?.map((e) => e) || [];
    return message;
  },
};

function createBaseLocatorServiceSubscriptionRequest(): LocatorServiceSubscriptionRequest {
  return { type: 0, device: undefined, excludeFixTypes: [] };
}

export const LocatorServiceSubscriptionRequest: MessageFns<LocatorServiceSubscriptionRequest> = {
  encode(message: LocatorServiceSubscriptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.device !== undefined) {
      DeviceSelector.encode(message.device, writer.uint32(18).fork()).join();
    }
    writer.uint32(26).fork();
    for (const v of message.excludeFixTypes) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocatorServiceSubscriptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocatorServiceSubscriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.device = DeviceSelector.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.excludeFixTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.excludeFixTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocatorServiceSubscriptionRequest {
    return {
      type: isSet(object.type) ? subscriptionRequestTypeFromJSON(object.type) : 0,
      device: isSet(object.device) ? DeviceSelector.fromJSON(object.device) : undefined,
      excludeFixTypes: globalThis.Array.isArray(object?.excludeFixTypes)
        ? object.excludeFixTypes.map((e: any) => fixTypeFromJSON(e))
        : globalThis.Array.isArray(object?.exclude_fix_types)
        ? object.exclude_fix_types.map((e: any) => fixTypeFromJSON(e))
        : [],
    };
  },

  toJSON(message: LocatorServiceSubscriptionRequest): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = subscriptionRequestTypeToJSON(message.type);
    }
    if (message.device !== undefined) {
      obj.device = DeviceSelector.toJSON(message.device);
    }
    if (message.excludeFixTypes?.length) {
      obj.excludeFixTypes = message.excludeFixTypes.map((e) => fixTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocatorServiceSubscriptionRequest>, I>>(
    base?: I,
  ): LocatorServiceSubscriptionRequest {
    return LocatorServiceSubscriptionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocatorServiceSubscriptionRequest>, I>>(
    object: I,
  ): LocatorServiceSubscriptionRequest {
    const message = createBaseLocatorServiceSubscriptionRequest();
    message.type = object.type ?? 0;
    message.device = (object.device !== undefined && object.device !== null)
      ? DeviceSelector.fromPartial(object.device)
      : undefined;
    message.excludeFixTypes = object.excludeFixTypes?.map((e) => e) || [];
    return message;
  },
};

function createBaseJobServiceSubscriptionRequest(): JobServiceSubscriptionRequest {
  return {
    type: 0,
    target: 0,
    jobId: undefined,
    objectiveId: undefined,
    robotSerial: undefined,
    taskId: undefined,
    userId: undefined,
  };
}

export const JobServiceSubscriptionRequest: MessageFns<JobServiceSubscriptionRequest> = {
  encode(message: JobServiceSubscriptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.target !== 0) {
      writer.uint32(16).int32(message.target);
    }
    if (message.jobId !== undefined) {
      writer.uint32(24).uint64(message.jobId);
    }
    if (message.objectiveId !== undefined) {
      writer.uint32(32).uint64(message.objectiveId);
    }
    if (message.robotSerial !== undefined) {
      writer.uint32(42).string(message.robotSerial);
    }
    if (message.taskId !== undefined) {
      writer.uint32(48).uint64(message.taskId);
    }
    if (message.userId !== undefined) {
      writer.uint32(58).string(message.userId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobServiceSubscriptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobServiceSubscriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.target = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.objectiveId = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.taskId = longToNumber(reader.uint64());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobServiceSubscriptionRequest {
    return {
      type: isSet(object.type) ? subscriptionRequestTypeFromJSON(object.type) : 0,
      target: isSet(object.target) ? jobServiceSubscriptionRequest_TargetFromJSON(object.target) : 0,
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : undefined,
      objectiveId: isSet(object.objectiveId)
        ? globalThis.Number(object.objectiveId)
        : isSet(object.objective_id)
        ? globalThis.Number(object.objective_id)
        : undefined,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : undefined,
      taskId: isSet(object.taskId)
        ? globalThis.Number(object.taskId)
        : isSet(object.task_id)
        ? globalThis.Number(object.task_id)
        : undefined,
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : undefined,
    };
  },

  toJSON(message: JobServiceSubscriptionRequest): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = subscriptionRequestTypeToJSON(message.type);
    }
    if (message.target !== 0) {
      obj.target = jobServiceSubscriptionRequest_TargetToJSON(message.target);
    }
    if (message.jobId !== undefined) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.objectiveId !== undefined) {
      obj.objectiveId = Math.round(message.objectiveId);
    }
    if (message.robotSerial !== undefined) {
      obj.robotSerial = message.robotSerial;
    }
    if (message.taskId !== undefined) {
      obj.taskId = Math.round(message.taskId);
    }
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobServiceSubscriptionRequest>, I>>(base?: I): JobServiceSubscriptionRequest {
    return JobServiceSubscriptionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobServiceSubscriptionRequest>, I>>(
    object: I,
  ): JobServiceSubscriptionRequest {
    const message = createBaseJobServiceSubscriptionRequest();
    message.type = object.type ?? 0;
    message.target = object.target ?? 0;
    message.jobId = object.jobId ?? undefined;
    message.objectiveId = object.objectiveId ?? undefined;
    message.robotSerial = object.robotSerial ?? undefined;
    message.taskId = object.taskId ?? undefined;
    message.userId = object.userId ?? undefined;
    return message;
  },
};

function createBaseDeviceSelector(): DeviceSelector {
  return { type: 0, serial: undefined, deviceId: undefined };
}

export const DeviceSelector: MessageFns<DeviceSelector> = {
  encode(message: DeviceSelector, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.serial !== undefined) {
      writer.uint32(18).string(message.serial);
    }
    if (message.deviceId !== undefined) {
      writer.uint32(26).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceSelector {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceSelector();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceSelector {
    return {
      type: isSet(object.type) ? subscriptionDeviceTypeFromJSON(object.type) : 0,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : undefined,
      deviceId: isSet(object.deviceId)
        ? globalThis.String(object.deviceId)
        : isSet(object.device_id)
        ? globalThis.String(object.device_id)
        : undefined,
    };
  },

  toJSON(message: DeviceSelector): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = subscriptionDeviceTypeToJSON(message.type);
    }
    if (message.serial !== undefined) {
      obj.serial = message.serial;
    }
    if (message.deviceId !== undefined) {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceSelector>, I>>(base?: I): DeviceSelector {
    return DeviceSelector.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceSelector>, I>>(object: I): DeviceSelector {
    const message = createBaseDeviceSelector();
    message.type = object.type ?? 0;
    message.serial = object.serial ?? undefined;
    message.deviceId = object.deviceId ?? undefined;
    return message;
  },
};

function createBaseSubscriptionMessage(): SubscriptionMessage {
  return { type: 0, location: undefined };
}

export const SubscriptionMessage: MessageFns<SubscriptionMessage> = {
  encode(message: SubscriptionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.location !== undefined) {
      LocationUpdate.encode(message.location, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscriptionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.location = LocationUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionMessage {
    return {
      type: isSet(object.type) ? subscriptionMessage_TypeFromJSON(object.type) : 0,
      location: isSet(object.location) ? LocationUpdate.fromJSON(object.location) : undefined,
    };
  },

  toJSON(message: SubscriptionMessage): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = subscriptionMessage_TypeToJSON(message.type);
    }
    if (message.location !== undefined) {
      obj.location = LocationUpdate.toJSON(message.location);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionMessage>, I>>(base?: I): SubscriptionMessage {
    return SubscriptionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionMessage>, I>>(object: I): SubscriptionMessage {
    const message = createBaseSubscriptionMessage();
    message.type = object.type ?? 0;
    message.location = (object.location !== undefined && object.location !== null)
      ? LocationUpdate.fromPartial(object.location)
      : undefined;
    return message;
  },
};

function createBaseLocatorServiceSubscriptionMessage(): LocatorServiceSubscriptionMessage {
  return { type: 0, location: undefined };
}

export const LocatorServiceSubscriptionMessage: MessageFns<LocatorServiceSubscriptionMessage> = {
  encode(message: LocatorServiceSubscriptionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.location !== undefined) {
      LocationUpdate.encode(message.location, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocatorServiceSubscriptionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocatorServiceSubscriptionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.location = LocationUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocatorServiceSubscriptionMessage {
    return {
      type: isSet(object.type) ? locatorServiceSubscriptionMessage_TypeFromJSON(object.type) : 0,
      location: isSet(object.location) ? LocationUpdate.fromJSON(object.location) : undefined,
    };
  },

  toJSON(message: LocatorServiceSubscriptionMessage): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = locatorServiceSubscriptionMessage_TypeToJSON(message.type);
    }
    if (message.location !== undefined) {
      obj.location = LocationUpdate.toJSON(message.location);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocatorServiceSubscriptionMessage>, I>>(
    base?: I,
  ): LocatorServiceSubscriptionMessage {
    return LocatorServiceSubscriptionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocatorServiceSubscriptionMessage>, I>>(
    object: I,
  ): LocatorServiceSubscriptionMessage {
    const message = createBaseLocatorServiceSubscriptionMessage();
    message.type = object.type ?? 0;
    message.location = (object.location !== undefined && object.location !== null)
      ? LocationUpdate.fromPartial(object.location)
      : undefined;
    return message;
  },
};

function createBasePivotAlertUnknownData(): PivotAlertUnknownData {
  return { reasons: [] };
}

export const PivotAlertUnknownData: MessageFns<PivotAlertUnknownData> = {
  encode(message: PivotAlertUnknownData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.reasons) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PivotAlertUnknownData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePivotAlertUnknownData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.reasons.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.reasons.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PivotAlertUnknownData {
    return {
      reasons: globalThis.Array.isArray(object?.reasons)
        ? object.reasons.map((e: any) => pivotAlertUnknownReasonFromJSON(e))
        : [],
    };
  },

  toJSON(message: PivotAlertUnknownData): unknown {
    const obj: any = {};
    if (message.reasons?.length) {
      obj.reasons = message.reasons.map((e) => pivotAlertUnknownReasonToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PivotAlertUnknownData>, I>>(base?: I): PivotAlertUnknownData {
    return PivotAlertUnknownData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PivotAlertUnknownData>, I>>(object: I): PivotAlertUnknownData {
    const message = createBasePivotAlertUnknownData();
    message.reasons = object.reasons?.map((e) => e) || [];
    return message;
  },
};

function createBasePivotAlertAlertedData(): PivotAlertAlertedData {
  return { responsiblePivotZoneId: "" };
}

export const PivotAlertAlertedData: MessageFns<PivotAlertAlertedData> = {
  encode(message: PivotAlertAlertedData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.responsiblePivotZoneId !== "") {
      writer.uint32(10).string(message.responsiblePivotZoneId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PivotAlertAlertedData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePivotAlertAlertedData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.responsiblePivotZoneId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PivotAlertAlertedData {
    return {
      responsiblePivotZoneId: isSet(object.responsiblePivotZoneId)
        ? globalThis.String(object.responsiblePivotZoneId)
        : isSet(object.responsible_pivot_zone_id)
        ? globalThis.String(object.responsible_pivot_zone_id)
        : "",
    };
  },

  toJSON(message: PivotAlertAlertedData): unknown {
    const obj: any = {};
    if (message.responsiblePivotZoneId !== "") {
      obj.responsiblePivotZoneId = message.responsiblePivotZoneId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PivotAlertAlertedData>, I>>(base?: I): PivotAlertAlertedData {
    return PivotAlertAlertedData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PivotAlertAlertedData>, I>>(object: I): PivotAlertAlertedData {
    const message = createBasePivotAlertAlertedData();
    message.responsiblePivotZoneId = object.responsiblePivotZoneId ?? "";
    return message;
  },
};

function createBasePivotAlertState(): PivotAlertState {
  return { robotSerial: "", unknown: undefined, allClear: undefined, alerted: undefined };
}

export const PivotAlertState: MessageFns<PivotAlertState> = {
  encode(message: PivotAlertState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    if (message.unknown !== undefined) {
      PivotAlertUnknownData.encode(message.unknown, writer.uint32(18).fork()).join();
    }
    if (message.allClear !== undefined) {
      Empty.encode(message.allClear, writer.uint32(26).fork()).join();
    }
    if (message.alerted !== undefined) {
      PivotAlertAlertedData.encode(message.alerted, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PivotAlertState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePivotAlertState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.unknown = PivotAlertUnknownData.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.allClear = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.alerted = PivotAlertAlertedData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PivotAlertState {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      unknown: isSet(object.unknown) ? PivotAlertUnknownData.fromJSON(object.unknown) : undefined,
      allClear: isSet(object.allClear)
        ? Empty.fromJSON(object.allClear)
        : isSet(object.all_clear)
        ? Empty.fromJSON(object.all_clear)
        : undefined,
      alerted: isSet(object.alerted) ? PivotAlertAlertedData.fromJSON(object.alerted) : undefined,
    };
  },

  toJSON(message: PivotAlertState): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.unknown !== undefined) {
      obj.unknown = PivotAlertUnknownData.toJSON(message.unknown);
    }
    if (message.allClear !== undefined) {
      obj.allClear = Empty.toJSON(message.allClear);
    }
    if (message.alerted !== undefined) {
      obj.alerted = PivotAlertAlertedData.toJSON(message.alerted);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PivotAlertState>, I>>(base?: I): PivotAlertState {
    return PivotAlertState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PivotAlertState>, I>>(object: I): PivotAlertState {
    const message = createBasePivotAlertState();
    message.robotSerial = object.robotSerial ?? "";
    message.unknown = (object.unknown !== undefined && object.unknown !== null)
      ? PivotAlertUnknownData.fromPartial(object.unknown)
      : undefined;
    message.allClear = (object.allClear !== undefined && object.allClear !== null)
      ? Empty.fromPartial(object.allClear)
      : undefined;
    message.alerted = (object.alerted !== undefined && object.alerted !== null)
      ? PivotAlertAlertedData.fromPartial(object.alerted)
      : undefined;
    return message;
  },
};

function createBaseLocationUpdate(): LocationUpdate {
  return { device: undefined, robotRec: undefined, deviceRec: undefined, pivotAlert: undefined };
}

export const LocationUpdate: MessageFns<LocationUpdate> = {
  encode(message: LocationUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.device !== undefined) {
      DeviceSelector.encode(message.device, writer.uint32(10).fork()).join();
    }
    if (message.robotRec !== undefined) {
      LocationHistoryRecord.encode(message.robotRec, writer.uint32(26).fork()).join();
    }
    if (message.deviceRec !== undefined) {
      DeviceLocationHistoryRecord.encode(message.deviceRec, writer.uint32(34).fork()).join();
    }
    if (message.pivotAlert !== undefined) {
      PivotAlertState.encode(message.pivotAlert, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocationUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocationUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.device = DeviceSelector.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.robotRec = LocationHistoryRecord.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deviceRec = DeviceLocationHistoryRecord.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.pivotAlert = PivotAlertState.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocationUpdate {
    return {
      device: isSet(object.device) ? DeviceSelector.fromJSON(object.device) : undefined,
      robotRec: isSet(object.robotRec)
        ? LocationHistoryRecord.fromJSON(object.robotRec)
        : isSet(object.robot_rec)
        ? LocationHistoryRecord.fromJSON(object.robot_rec)
        : undefined,
      deviceRec: isSet(object.deviceRec)
        ? DeviceLocationHistoryRecord.fromJSON(object.deviceRec)
        : isSet(object.device_rec)
        ? DeviceLocationHistoryRecord.fromJSON(object.device_rec)
        : undefined,
      pivotAlert: isSet(object.pivotAlert)
        ? PivotAlertState.fromJSON(object.pivotAlert)
        : isSet(object.pivot_alert)
        ? PivotAlertState.fromJSON(object.pivot_alert)
        : undefined,
    };
  },

  toJSON(message: LocationUpdate): unknown {
    const obj: any = {};
    if (message.device !== undefined) {
      obj.device = DeviceSelector.toJSON(message.device);
    }
    if (message.robotRec !== undefined) {
      obj.robotRec = LocationHistoryRecord.toJSON(message.robotRec);
    }
    if (message.deviceRec !== undefined) {
      obj.deviceRec = DeviceLocationHistoryRecord.toJSON(message.deviceRec);
    }
    if (message.pivotAlert !== undefined) {
      obj.pivotAlert = PivotAlertState.toJSON(message.pivotAlert);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocationUpdate>, I>>(base?: I): LocationUpdate {
    return LocationUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocationUpdate>, I>>(object: I): LocationUpdate {
    const message = createBaseLocationUpdate();
    message.device = (object.device !== undefined && object.device !== null)
      ? DeviceSelector.fromPartial(object.device)
      : undefined;
    message.robotRec = (object.robotRec !== undefined && object.robotRec !== null)
      ? LocationHistoryRecord.fromPartial(object.robotRec)
      : undefined;
    message.deviceRec = (object.deviceRec !== undefined && object.deviceRec !== null)
      ? DeviceLocationHistoryRecord.fromPartial(object.deviceRec)
      : undefined;
    message.pivotAlert = (object.pivotAlert !== undefined && object.pivotAlert !== null)
      ? PivotAlertState.fromPartial(object.pivotAlert)
      : undefined;
    return message;
  },
};

function createBaseJobServiceSubscriptionMessage(): JobServiceSubscriptionMessage {
  return {
    type: 0,
    activeObjective: undefined,
    activeAtomicTask: undefined,
    job: undefined,
    objective: undefined,
    task: undefined,
    intervention: undefined,
    objectiveAssignment: undefined,
    jobConfig: undefined,
    checklist: undefined,
    checklistExemption: undefined,
    jobAssignment: undefined,
    intervenerSession: undefined,
  };
}

export const JobServiceSubscriptionMessage: MessageFns<JobServiceSubscriptionMessage> = {
  encode(message: JobServiceSubscriptionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.activeObjective !== undefined) {
      ActiveObjectiveUpdate.encode(message.activeObjective, writer.uint32(18).fork()).join();
    }
    if (message.activeAtomicTask !== undefined) {
      ActiveAtomicTaskUpdate.encode(message.activeAtomicTask, writer.uint32(26).fork()).join();
    }
    if (message.job !== undefined) {
      JobUpdate.encode(message.job, writer.uint32(34).fork()).join();
    }
    if (message.objective !== undefined) {
      ObjectiveUpdate.encode(message.objective, writer.uint32(42).fork()).join();
    }
    if (message.task !== undefined) {
      TaskUpdate.encode(message.task, writer.uint32(50).fork()).join();
    }
    if (message.intervention !== undefined) {
      InterventionUpdate.encode(message.intervention, writer.uint32(58).fork()).join();
    }
    if (message.objectiveAssignment !== undefined) {
      ObjectiveAssignmentUpdate.encode(message.objectiveAssignment, writer.uint32(66).fork()).join();
    }
    if (message.jobConfig !== undefined) {
      JobConfigUpdate.encode(message.jobConfig, writer.uint32(74).fork()).join();
    }
    if (message.checklist !== undefined) {
      ChecklistUpdate.encode(message.checklist, writer.uint32(82).fork()).join();
    }
    if (message.checklistExemption !== undefined) {
      ChecklistExemptionUpdate.encode(message.checklistExemption, writer.uint32(90).fork()).join();
    }
    if (message.jobAssignment !== undefined) {
      JobAssignmentUpdate.encode(message.jobAssignment, writer.uint32(98).fork()).join();
    }
    if (message.intervenerSession !== undefined) {
      IntervenerSessionUpdate.encode(message.intervenerSession, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobServiceSubscriptionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobServiceSubscriptionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.activeObjective = ActiveObjectiveUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.activeAtomicTask = ActiveAtomicTaskUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.job = JobUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.objective = ObjectiveUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.task = TaskUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.intervention = InterventionUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.objectiveAssignment = ObjectiveAssignmentUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.jobConfig = JobConfigUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.checklist = ChecklistUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.checklistExemption = ChecklistExemptionUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.jobAssignment = JobAssignmentUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.intervenerSession = IntervenerSessionUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobServiceSubscriptionMessage {
    return {
      type: isSet(object.type) ? jobServiceSubscriptionMessage_TypeFromJSON(object.type) : 0,
      activeObjective: isSet(object.activeObjective)
        ? ActiveObjectiveUpdate.fromJSON(object.activeObjective)
        : isSet(object.active_objective)
        ? ActiveObjectiveUpdate.fromJSON(object.active_objective)
        : undefined,
      activeAtomicTask: isSet(object.activeAtomicTask)
        ? ActiveAtomicTaskUpdate.fromJSON(object.activeAtomicTask)
        : isSet(object.active_atomic_task)
        ? ActiveAtomicTaskUpdate.fromJSON(object.active_atomic_task)
        : undefined,
      job: isSet(object.job) ? JobUpdate.fromJSON(object.job) : undefined,
      objective: isSet(object.objective) ? ObjectiveUpdate.fromJSON(object.objective) : undefined,
      task: isSet(object.task) ? TaskUpdate.fromJSON(object.task) : undefined,
      intervention: isSet(object.intervention) ? InterventionUpdate.fromJSON(object.intervention) : undefined,
      objectiveAssignment: isSet(object.objectiveAssignment)
        ? ObjectiveAssignmentUpdate.fromJSON(object.objectiveAssignment)
        : isSet(object.objective_assignment)
        ? ObjectiveAssignmentUpdate.fromJSON(object.objective_assignment)
        : undefined,
      jobConfig: isSet(object.jobConfig)
        ? JobConfigUpdate.fromJSON(object.jobConfig)
        : isSet(object.job_config)
        ? JobConfigUpdate.fromJSON(object.job_config)
        : undefined,
      checklist: isSet(object.checklist) ? ChecklistUpdate.fromJSON(object.checklist) : undefined,
      checklistExemption: isSet(object.checklistExemption)
        ? ChecklistExemptionUpdate.fromJSON(object.checklistExemption)
        : isSet(object.checklist_exemption)
        ? ChecklistExemptionUpdate.fromJSON(object.checklist_exemption)
        : undefined,
      jobAssignment: isSet(object.jobAssignment)
        ? JobAssignmentUpdate.fromJSON(object.jobAssignment)
        : isSet(object.job_assignment)
        ? JobAssignmentUpdate.fromJSON(object.job_assignment)
        : undefined,
      intervenerSession: isSet(object.intervenerSession)
        ? IntervenerSessionUpdate.fromJSON(object.intervenerSession)
        : isSet(object.intervener_session)
        ? IntervenerSessionUpdate.fromJSON(object.intervener_session)
        : undefined,
    };
  },

  toJSON(message: JobServiceSubscriptionMessage): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = jobServiceSubscriptionMessage_TypeToJSON(message.type);
    }
    if (message.activeObjective !== undefined) {
      obj.activeObjective = ActiveObjectiveUpdate.toJSON(message.activeObjective);
    }
    if (message.activeAtomicTask !== undefined) {
      obj.activeAtomicTask = ActiveAtomicTaskUpdate.toJSON(message.activeAtomicTask);
    }
    if (message.job !== undefined) {
      obj.job = JobUpdate.toJSON(message.job);
    }
    if (message.objective !== undefined) {
      obj.objective = ObjectiveUpdate.toJSON(message.objective);
    }
    if (message.task !== undefined) {
      obj.task = TaskUpdate.toJSON(message.task);
    }
    if (message.intervention !== undefined) {
      obj.intervention = InterventionUpdate.toJSON(message.intervention);
    }
    if (message.objectiveAssignment !== undefined) {
      obj.objectiveAssignment = ObjectiveAssignmentUpdate.toJSON(message.objectiveAssignment);
    }
    if (message.jobConfig !== undefined) {
      obj.jobConfig = JobConfigUpdate.toJSON(message.jobConfig);
    }
    if (message.checklist !== undefined) {
      obj.checklist = ChecklistUpdate.toJSON(message.checklist);
    }
    if (message.checklistExemption !== undefined) {
      obj.checklistExemption = ChecklistExemptionUpdate.toJSON(message.checklistExemption);
    }
    if (message.jobAssignment !== undefined) {
      obj.jobAssignment = JobAssignmentUpdate.toJSON(message.jobAssignment);
    }
    if (message.intervenerSession !== undefined) {
      obj.intervenerSession = IntervenerSessionUpdate.toJSON(message.intervenerSession);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobServiceSubscriptionMessage>, I>>(base?: I): JobServiceSubscriptionMessage {
    return JobServiceSubscriptionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobServiceSubscriptionMessage>, I>>(
    object: I,
  ): JobServiceSubscriptionMessage {
    const message = createBaseJobServiceSubscriptionMessage();
    message.type = object.type ?? 0;
    message.activeObjective = (object.activeObjective !== undefined && object.activeObjective !== null)
      ? ActiveObjectiveUpdate.fromPartial(object.activeObjective)
      : undefined;
    message.activeAtomicTask = (object.activeAtomicTask !== undefined && object.activeAtomicTask !== null)
      ? ActiveAtomicTaskUpdate.fromPartial(object.activeAtomicTask)
      : undefined;
    message.job = (object.job !== undefined && object.job !== null) ? JobUpdate.fromPartial(object.job) : undefined;
    message.objective = (object.objective !== undefined && object.objective !== null)
      ? ObjectiveUpdate.fromPartial(object.objective)
      : undefined;
    message.task = (object.task !== undefined && object.task !== null)
      ? TaskUpdate.fromPartial(object.task)
      : undefined;
    message.intervention = (object.intervention !== undefined && object.intervention !== null)
      ? InterventionUpdate.fromPartial(object.intervention)
      : undefined;
    message.objectiveAssignment = (object.objectiveAssignment !== undefined && object.objectiveAssignment !== null)
      ? ObjectiveAssignmentUpdate.fromPartial(object.objectiveAssignment)
      : undefined;
    message.jobConfig = (object.jobConfig !== undefined && object.jobConfig !== null)
      ? JobConfigUpdate.fromPartial(object.jobConfig)
      : undefined;
    message.checklist = (object.checklist !== undefined && object.checklist !== null)
      ? ChecklistUpdate.fromPartial(object.checklist)
      : undefined;
    message.checklistExemption = (object.checklistExemption !== undefined && object.checklistExemption !== null)
      ? ChecklistExemptionUpdate.fromPartial(object.checklistExemption)
      : undefined;
    message.jobAssignment = (object.jobAssignment !== undefined && object.jobAssignment !== null)
      ? JobAssignmentUpdate.fromPartial(object.jobAssignment)
      : undefined;
    message.intervenerSession = (object.intervenerSession !== undefined && object.intervenerSession !== null)
      ? IntervenerSessionUpdate.fromPartial(object.intervenerSession)
      : undefined;
    return message;
  },
};

function createBaseActiveObjectiveUpdate(): ActiveObjectiveUpdate {
  return { type: 0, objective: undefined };
}

export const ActiveObjectiveUpdate: MessageFns<ActiveObjectiveUpdate> = {
  encode(message: ActiveObjectiveUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.objective !== undefined) {
      Objective.encode(message.objective, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActiveObjectiveUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveObjectiveUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.objective = Objective.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActiveObjectiveUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      objective: isSet(object.objective) ? Objective.fromJSON(object.objective) : undefined,
    };
  },

  toJSON(message: ActiveObjectiveUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.objective !== undefined) {
      obj.objective = Objective.toJSON(message.objective);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActiveObjectiveUpdate>, I>>(base?: I): ActiveObjectiveUpdate {
    return ActiveObjectiveUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActiveObjectiveUpdate>, I>>(object: I): ActiveObjectiveUpdate {
    const message = createBaseActiveObjectiveUpdate();
    message.type = object.type ?? 0;
    message.objective = (object.objective !== undefined && object.objective !== null)
      ? Objective.fromPartial(object.objective)
      : undefined;
    return message;
  },
};

function createBaseActiveAtomicTaskUpdate(): ActiveAtomicTaskUpdate {
  return { type: 0, task: undefined };
}

export const ActiveAtomicTaskUpdate: MessageFns<ActiveAtomicTaskUpdate> = {
  encode(message: ActiveAtomicTaskUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.task !== undefined) {
      Task.encode(message.task, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActiveAtomicTaskUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveAtomicTaskUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.task = Task.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActiveAtomicTaskUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      task: isSet(object.task) ? Task.fromJSON(object.task) : undefined,
    };
  },

  toJSON(message: ActiveAtomicTaskUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.task !== undefined) {
      obj.task = Task.toJSON(message.task);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActiveAtomicTaskUpdate>, I>>(base?: I): ActiveAtomicTaskUpdate {
    return ActiveAtomicTaskUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActiveAtomicTaskUpdate>, I>>(object: I): ActiveAtomicTaskUpdate {
    const message = createBaseActiveAtomicTaskUpdate();
    message.type = object.type ?? 0;
    message.task = (object.task !== undefined && object.task !== null) ? Task.fromPartial(object.task) : undefined;
    return message;
  },
};

function createBaseJobUpdate(): JobUpdate {
  return { type: 0, job: undefined };
}

export const JobUpdate: MessageFns<JobUpdate> = {
  encode(message: JobUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.job !== undefined) {
      Job.encode(message.job, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.job = Job.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      job: isSet(object.job) ? Job.fromJSON(object.job) : undefined,
    };
  },

  toJSON(message: JobUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.job !== undefined) {
      obj.job = Job.toJSON(message.job);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobUpdate>, I>>(base?: I): JobUpdate {
    return JobUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobUpdate>, I>>(object: I): JobUpdate {
    const message = createBaseJobUpdate();
    message.type = object.type ?? 0;
    message.job = (object.job !== undefined && object.job !== null) ? Job.fromPartial(object.job) : undefined;
    return message;
  },
};

function createBaseJobConfigUpdate(): JobConfigUpdate {
  return { type: 0, configuration: undefined };
}

export const JobConfigUpdate: MessageFns<JobConfigUpdate> = {
  encode(message: JobConfigUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.configuration !== undefined) {
      JobConfiguration.encode(message.configuration, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobConfigUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobConfigUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.configuration = JobConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobConfigUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      configuration: isSet(object.configuration) ? JobConfiguration.fromJSON(object.configuration) : undefined,
    };
  },

  toJSON(message: JobConfigUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.configuration !== undefined) {
      obj.configuration = JobConfiguration.toJSON(message.configuration);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobConfigUpdate>, I>>(base?: I): JobConfigUpdate {
    return JobConfigUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobConfigUpdate>, I>>(object: I): JobConfigUpdate {
    const message = createBaseJobConfigUpdate();
    message.type = object.type ?? 0;
    message.configuration = (object.configuration !== undefined && object.configuration !== null)
      ? JobConfiguration.fromPartial(object.configuration)
      : undefined;
    return message;
  },
};

function createBaseObjectiveUpdate(): ObjectiveUpdate {
  return { type: 0, objective: undefined };
}

export const ObjectiveUpdate: MessageFns<ObjectiveUpdate> = {
  encode(message: ObjectiveUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.objective !== undefined) {
      Objective.encode(message.objective, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObjectiveUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjectiveUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.objective = Objective.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObjectiveUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      objective: isSet(object.objective) ? Objective.fromJSON(object.objective) : undefined,
    };
  },

  toJSON(message: ObjectiveUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.objective !== undefined) {
      obj.objective = Objective.toJSON(message.objective);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObjectiveUpdate>, I>>(base?: I): ObjectiveUpdate {
    return ObjectiveUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObjectiveUpdate>, I>>(object: I): ObjectiveUpdate {
    const message = createBaseObjectiveUpdate();
    message.type = object.type ?? 0;
    message.objective = (object.objective !== undefined && object.objective !== null)
      ? Objective.fromPartial(object.objective)
      : undefined;
    return message;
  },
};

function createBaseTaskUpdate(): TaskUpdate {
  return { type: 0, task: undefined };
}

export const TaskUpdate: MessageFns<TaskUpdate> = {
  encode(message: TaskUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.task !== undefined) {
      Task.encode(message.task, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TaskUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTaskUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.task = Task.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TaskUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      task: isSet(object.task) ? Task.fromJSON(object.task) : undefined,
    };
  },

  toJSON(message: TaskUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.task !== undefined) {
      obj.task = Task.toJSON(message.task);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TaskUpdate>, I>>(base?: I): TaskUpdate {
    return TaskUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TaskUpdate>, I>>(object: I): TaskUpdate {
    const message = createBaseTaskUpdate();
    message.type = object.type ?? 0;
    message.task = (object.task !== undefined && object.task !== null) ? Task.fromPartial(object.task) : undefined;
    return message;
  },
};

function createBaseInterventionUpdate(): InterventionUpdate {
  return { type: 0, intervention: undefined };
}

export const InterventionUpdate: MessageFns<InterventionUpdate> = {
  encode(message: InterventionUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.intervention !== undefined) {
      Intervention.encode(message.intervention, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InterventionUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterventionUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.intervention = Intervention.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InterventionUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      intervention: isSet(object.intervention) ? Intervention.fromJSON(object.intervention) : undefined,
    };
  },

  toJSON(message: InterventionUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.intervention !== undefined) {
      obj.intervention = Intervention.toJSON(message.intervention);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InterventionUpdate>, I>>(base?: I): InterventionUpdate {
    return InterventionUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InterventionUpdate>, I>>(object: I): InterventionUpdate {
    const message = createBaseInterventionUpdate();
    message.type = object.type ?? 0;
    message.intervention = (object.intervention !== undefined && object.intervention !== null)
      ? Intervention.fromPartial(object.intervention)
      : undefined;
    return message;
  },
};

function createBaseIntervenerSessionUpdate(): IntervenerSessionUpdate {
  return { type: 0, session: undefined };
}

export const IntervenerSessionUpdate: MessageFns<IntervenerSessionUpdate> = {
  encode(message: IntervenerSessionUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.session !== undefined) {
      ActiveIntervener.encode(message.session, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntervenerSessionUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntervenerSessionUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.session = ActiveIntervener.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntervenerSessionUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      session: isSet(object.session) ? ActiveIntervener.fromJSON(object.session) : undefined,
    };
  },

  toJSON(message: IntervenerSessionUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.session !== undefined) {
      obj.session = ActiveIntervener.toJSON(message.session);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IntervenerSessionUpdate>, I>>(base?: I): IntervenerSessionUpdate {
    return IntervenerSessionUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IntervenerSessionUpdate>, I>>(object: I): IntervenerSessionUpdate {
    const message = createBaseIntervenerSessionUpdate();
    message.type = object.type ?? 0;
    message.session = (object.session !== undefined && object.session !== null)
      ? ActiveIntervener.fromPartial(object.session)
      : undefined;
    return message;
  },
};

function createBaseJobAssignmentUpdate(): JobAssignmentUpdate {
  return { type: 0, jobAssignment: undefined };
}

export const JobAssignmentUpdate: MessageFns<JobAssignmentUpdate> = {
  encode(message: JobAssignmentUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.jobAssignment !== undefined) {
      RobotJobAssignment.encode(message.jobAssignment, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobAssignmentUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobAssignmentUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.jobAssignment = RobotJobAssignment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobAssignmentUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      jobAssignment: isSet(object.jobAssignment)
        ? RobotJobAssignment.fromJSON(object.jobAssignment)
        : isSet(object.job_assignment)
        ? RobotJobAssignment.fromJSON(object.job_assignment)
        : undefined,
    };
  },

  toJSON(message: JobAssignmentUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.jobAssignment !== undefined) {
      obj.jobAssignment = RobotJobAssignment.toJSON(message.jobAssignment);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobAssignmentUpdate>, I>>(base?: I): JobAssignmentUpdate {
    return JobAssignmentUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobAssignmentUpdate>, I>>(object: I): JobAssignmentUpdate {
    const message = createBaseJobAssignmentUpdate();
    message.type = object.type ?? 0;
    message.jobAssignment = (object.jobAssignment !== undefined && object.jobAssignment !== null)
      ? RobotJobAssignment.fromPartial(object.jobAssignment)
      : undefined;
    return message;
  },
};

function createBaseObjectiveAssignmentUpdate(): ObjectiveAssignmentUpdate {
  return { type: 0, objectiveAssignment: undefined };
}

export const ObjectiveAssignmentUpdate: MessageFns<ObjectiveAssignmentUpdate> = {
  encode(message: ObjectiveAssignmentUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.objectiveAssignment !== undefined) {
      ObjectiveAssignment.encode(message.objectiveAssignment, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObjectiveAssignmentUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjectiveAssignmentUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.objectiveAssignment = ObjectiveAssignment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObjectiveAssignmentUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      objectiveAssignment: isSet(object.objectiveAssignment)
        ? ObjectiveAssignment.fromJSON(object.objectiveAssignment)
        : isSet(object.objective_assignment)
        ? ObjectiveAssignment.fromJSON(object.objective_assignment)
        : undefined,
    };
  },

  toJSON(message: ObjectiveAssignmentUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.objectiveAssignment !== undefined) {
      obj.objectiveAssignment = ObjectiveAssignment.toJSON(message.objectiveAssignment);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObjectiveAssignmentUpdate>, I>>(base?: I): ObjectiveAssignmentUpdate {
    return ObjectiveAssignmentUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObjectiveAssignmentUpdate>, I>>(object: I): ObjectiveAssignmentUpdate {
    const message = createBaseObjectiveAssignmentUpdate();
    message.type = object.type ?? 0;
    message.objectiveAssignment = (object.objectiveAssignment !== undefined && object.objectiveAssignment !== null)
      ? ObjectiveAssignment.fromPartial(object.objectiveAssignment)
      : undefined;
    return message;
  },
};

function createBaseChecklistUpdate(): ChecklistUpdate {
  return { type: 0, checklist: undefined };
}

export const ChecklistUpdate: MessageFns<ChecklistUpdate> = {
  encode(message: ChecklistUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.checklist !== undefined) {
      Checklist.encode(message.checklist, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.checklist = Checklist.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      checklist: isSet(object.checklist) ? Checklist.fromJSON(object.checklist) : undefined,
    };
  },

  toJSON(message: ChecklistUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.checklist !== undefined) {
      obj.checklist = Checklist.toJSON(message.checklist);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistUpdate>, I>>(base?: I): ChecklistUpdate {
    return ChecklistUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistUpdate>, I>>(object: I): ChecklistUpdate {
    const message = createBaseChecklistUpdate();
    message.type = object.type ?? 0;
    message.checklist = (object.checklist !== undefined && object.checklist !== null)
      ? Checklist.fromPartial(object.checklist)
      : undefined;
    return message;
  },
};

function createBaseChecklistExemptionUpdate(): ChecklistExemptionUpdate {
  return { type: 0, checklistExemption: undefined };
}

export const ChecklistExemptionUpdate: MessageFns<ChecklistExemptionUpdate> = {
  encode(message: ChecklistExemptionUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.checklistExemption !== undefined) {
      ChecklistExemption.encode(message.checklistExemption, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistExemptionUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistExemptionUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.checklistExemption = ChecklistExemption.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistExemptionUpdate {
    return {
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      checklistExemption: isSet(object.checklistExemption)
        ? ChecklistExemption.fromJSON(object.checklistExemption)
        : isSet(object.checklist_exemption)
        ? ChecklistExemption.fromJSON(object.checklist_exemption)
        : undefined,
    };
  },

  toJSON(message: ChecklistExemptionUpdate): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type);
    }
    if (message.checklistExemption !== undefined) {
      obj.checklistExemption = ChecklistExemption.toJSON(message.checklistExemption);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistExemptionUpdate>, I>>(base?: I): ChecklistExemptionUpdate {
    return ChecklistExemptionUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistExemptionUpdate>, I>>(object: I): ChecklistExemptionUpdate {
    const message = createBaseChecklistExemptionUpdate();
    message.type = object.type ?? 0;
    message.checklistExemption = (object.checklistExemption !== undefined && object.checklistExemption !== null)
      ? ChecklistExemption.fromPartial(object.checklistExemption)
      : undefined;
    return message;
  },
};

function createBaseWebSocketAuthenticateRequest(): WebSocketAuthenticateRequest {
  return { token: "", audience: "" };
}

export const WebSocketAuthenticateRequest: MessageFns<WebSocketAuthenticateRequest> = {
  encode(message: WebSocketAuthenticateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.audience !== "") {
      writer.uint32(18).string(message.audience);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebSocketAuthenticateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketAuthenticateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.token = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.audience = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketAuthenticateRequest {
    return {
      token: isSet(object.token) ? globalThis.String(object.token) : "",
      audience: isSet(object.audience) ? globalThis.String(object.audience) : "",
    };
  },

  toJSON(message: WebSocketAuthenticateRequest): unknown {
    const obj: any = {};
    if (message.token !== "") {
      obj.token = message.token;
    }
    if (message.audience !== "") {
      obj.audience = message.audience;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketAuthenticateRequest>, I>>(base?: I): WebSocketAuthenticateRequest {
    return WebSocketAuthenticateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketAuthenticateRequest>, I>>(object: I): WebSocketAuthenticateRequest {
    const message = createBaseWebSocketAuthenticateRequest();
    message.token = object.token ?? "";
    message.audience = object.audience ?? "";
    return message;
  },
};

function createBaseWebSocketResponse(): WebSocketResponse {
  return { status: 0, message: "" };
}

export const WebSocketResponse: MessageFns<WebSocketResponse> = {
  encode(message: WebSocketResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebSocketResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketResponse {
    return {
      status: isSet(object.status) ? webSocketStatusFromJSON(object.status) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: WebSocketResponse): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = webSocketStatusToJSON(message.status);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketResponse>, I>>(base?: I): WebSocketResponse {
    return WebSocketResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketResponse>, I>>(object: I): WebSocketResponse {
    const message = createBaseWebSocketResponse();
    message.status = object.status ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
